<template>
	<div class="bg-gray">
		<BaseNav></BaseNav>
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`"></div>
			<div class="container">
				<div class="search-box">
					<div class="flex align-center">
						<img src="../../assets/search.png" alt="">
						<input type="text" class="input-search" v-model="keywords" placeholder="请输入你要搜索的内容">
					</div>
					<div class="flex align-center">
						<a-divider style="margin-right: 30px;margin-top:5px;" type="vertical" />
						<a @click="doSearch" class="search-btn color-1a font-18">搜索</a>
					</div>
				</div>
				<div class="main">
					<div class="slide">
						<div class="item active" >
							<div class="title flex align-center">
								<div class="line"></div><span class="margin-left-5">结果分类</span>
							</div>
							<div class="item-content">
								<ul>
									<li :class="menuId==-1?'active':''" @click="chooseMenu(-1)">
										<div>全部</div>
									</li>
									<li :class="menuId==item.HomeMenu.id?'active':''" v-for="(item,index) in searchMenu" @click="chooseMenu(item.HomeMenu.id)">
										<div>{{item.HomeMenu.menu}}</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="item active">
							<div class="title flex align-center">
								<div class="line"></div><span class="margin-left-5">查询范围</span>
							</div>
							<div class="item-content">
								<ul>
									<li v-for="(item,index) in rangeList" @click="chooseRange(item.value)" :class="range==item.value?'active':''">
										<div>{{item.text}}</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="item active">
							<div class="title flex align-center">
								<div class="line"></div><span class="margin-left-5">时间范围</span>
							</div>
							<div class="item-content">
								<ul>
									<li v-for="(item,index) in timesList" @click="chooseTimes(item.value)" :class="times==item.value?'active':''">
										<div>{{item.text}}</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="main-content margin-bottom-15">
						<div class="flex justify-between align-center search_over">
							<div class="flex align-center">
								<img src="../../assets/search.png" alt=""><span class="margin-left-5 font-20">搜索结果</span>
							</div>
							<div>{{newsList.total}}条信息</div>
						</div>
						<div class="list">
							<div class="item" v-for="(item,index) in newsList.records">
								<router-link :to="{path:'/news/info',query:{newsId:item.id}}">
									{{item.newsTitle}}
								</router-link>
								<p class="font-14 color-999 margin-top-15">{{item.content}}</p>
								<div class="flex justify-between">
									<span class="font-14">{{item.releaseTime}}</span>
									<!-- <span class="font-14">发布人：河北股权交易所</span> -->
								</div>
							</div>
						</div>
						<div v-if="newsList==''" class="margin-top-30">
							<a-empty :description="false" />
						</div>
						<div class="margin-top-30 text-center">
							<a-pagination show-quick-jumper :default-current="1" :total="newsList.total" @change="onChange" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="clear"></div>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	export default {
		components: {
			BaseNav,
			BaseFooter,
		},
		data() {
			return {
				headBg: require("../../assets/news_bg.png"),
				keywords: "",
				searchMenu:[],
				menuId:-1,
				currentMenu:"",
				rangeList:[{text:"所有结果",value:0},{text:"标题",value:1},{text:"正文",value:2}],
				range:0,
				timesList:[{text:"时间不限",value:0},{text:"一天内",value:1},{text:"一周内",value:2},{text:"一月内",value:3},{text:"一年内",value:4}],
				times:0,
				page:1,
				newsList:'',
			}
		},
		created() {
			document.title = "雄安股权交易所-搜索新闻";
			this.keywords = this.$route.query.keywords;
			this.doSearch();
			this.getSearchMenu();
		},
		mounted() {
			this.doSearch();
		},
		methods: {
			reback() {
				window.history.go(-1);
			},
			// 选择时间
			chooseTimes(val){
				this.times = val;
				this.doSearch();
			},
			//选择查询范围
			chooseRange(val){
				this.range = val;
				this.doSearch();
			},
			//选择分类
			chooseMenu(id){
				this.menuId = id;
				console.log(this.menuId);
				this.doSearch();
			},
			// 获取搜索分类
			getSearchMenu(){
				this.$request({
					url:this.$api.search.querySearchMenu,
				}).then((res)=>{
					this.searchMenu = res.data.result;
					console.log(this.searchMenu);
				})
			},
			onChange(data) {
				this.page = data;
				this.doSearch();
			},
			doSearch() {
				let _Query = {
					newsTitle:this.keywords,
					menuId:this.menuId,
					pageNo:this.page,
					range:this.range,
					times:this.times
				}
				
				if(this.menuId == -1){
					_Query.menuId = ''
				}
				if(this.range==0){
					_Query.range = ''
				}
				if(this.times==0){
					_Query.times = ''
				}
				
				this.getNewsList(_Query);
			},
			getNewsList(query){
				this.$request({
					url:this.$api.search.search,
					data:query
				}).then((res)=>{
					console.log(res.data.result);
					this.newsList = res.data.result;
				})
			}
		}
	}
</script>

<style scoped>
	.bg-gray {
		background: #F6F7FC;
	}

	.search-box {
		width: 1200px;
		border-radius: 8px;
		padding: 25px;
		background-color: #FFFFFF;
		box-shadow: 0px 0px 8px rgba(30, 34, 170, 0.08);
		z-index: 999;
		display: flex;
		margin-top: -50px;
		justify-content: space-between;
		align-items: center;
	}

	.input-search {
		margin-left: 30px;
		font-size: 18px;
		border: none;
		outline: none !important;
		width: 1000px;
	}

	.nav {
		width: 1200px;
		height: 100px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		margin-top: -50px;
		padding: 40px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 115px;
	}

	.head-bg p {
		font-size: 24px;
	}

	.main {
		margin-top: 15px;
	}
	
	.search_over{
		border-bottom: 1px solid #E6E6E6;
		padding-bottom: 20px;
	}

	.main .slide {
		width: 250px;
		float: left;
		background: #FFFFFF;
		border-radius: 8px;
		margin-bottom: 15px;
	}

	.main .slide .item {
		font-size: 18px;
		border-bottom: 1px solid #F0F2FC;
	}

	.main .slide .item .title {
		padding: 15px 30px;
		font-weight: bold;
		cursor: pointer;
	}

	.main .slide .item .title .line {
		display: none;
	}

	.main .slide .active .title .line {
		display: block;
	}

	.main .slide .item .item-content {
		background-color: #F0F2FC;
		padding: 24px 40px;
		display: none;
	}

	.main .slide .active .item-content {
		display: block;
	}

	.main .slide .item .item-content ul {
		border-left: 2px solid #DBDCE6;
		padding-left: 15px;
	}

	.main .slide .item .item-content ul li {
		list-style: none;
		font-size: 16px;
		margin-bottom: 18px;
		cursor: pointer;
	}

	.main .slide .item .item-content ul li a {
		color: #999999;
	}


	.main .slide .item .item-content ul .active {
		border-left: 2px solid #13B8EE;
		padding-left: 15px;
		margin-left: -16px;
	}

	.main .slide .item .item-content ul .active {
		color: #13B8EE;
	}

	.main .main-content {
		width: 930px;
		float: right;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 40px;
	}


	.main .main-content .list .item {
		padding-bottom: 23px;
		padding-top: 23px;
		border-bottom: 1px solid #D9D9D9;
		font-size: 16px;
	}



	.main .main-content .list .item:hover {
		border-bottom: 1px solid #13B8EE;
	}

	.main .main-content .list .item:hover a {
		color: #13B8EE;
	}

	.main .main-content .list .item a {
		color: #1A1A1A;
	}

	.main .main-content .list .item span {
		color: #999999;
	}

	.reback {
		cursor: pointer;
	}

	.reback:hover {
		color: #13B8EE;
	}

	.line {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
	}

	.clear {
		clear: both;
	}
</style>



// WEBPACK FOOTER //
// src/pages/search/searchNews.vue